export default __webpack_public_path__ + "static/media/apple-store.b580fd1d.png";